define.alias("shared/components/shared/media-items/media-item", "settings/components/shared/media-items/media-item");